<div
  style="
    margin-bottom: 0.25em;
    border: solid 1px #ddd;
    padding: 0.5em;
    background-color: #fff;
    font-size: 12px;
  "
>
  <!-- == -->
  <div
    fxFlex="4"
    style="display: flex; justify-content: center; align-items: center"
  >
    <div>
      <mat-checkbox
        class="example-margin"
        [(ngModel)]="checked"
        [(indeterminate)]="indeterminate"
        [labelPosition]="labelPosition"
        [disabled]="disabled"
      >
      </mat-checkbox>
    </div>
  </div>

  <!-- == -->
  <div
    fxFlex="4"
    style="display: flex; justify-content: center; align-items: center"
  >
    <div>
      {{ cardContent.card_id }}
    </div>
  </div>

  <!-- == -->
  <div
    fxFlex="14"
    style="
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #000;
    "
  >
    <img
      *ngIf="cardContent.card_image_url"
      style="height: 50px; width: 100%; object-fit: cover"
      src="{{ cardContent.card_image_url }}"
    />

    <img
      *ngIf="!cardContent.card_image_url"
      style="height: 50px; width: 100%; object-fit: cover"
      src="https://wikipapa.org/images/img-no-disponible-large.jpg"
    />
  </div>
  <!-- == -->
  <div
    fxFlex="14"
    style="display: flex; justify-content: center; align-items: center"
  >
    <div>
      <span>{{ cardContent.card_name }}</span
      ><br />
    </div>
  </div>
  <!-- == -->
  <div
    fxFlex="14"
    style="display: flex; justify-content: center; align-items: center"
  >
    <mat-icon style="color: #8b2f00">account_circle</mat-icon>

    <span>{{ cardContent.card_username }}</span>
  </div>
  <!-- == -->
  <div
    fxFlex="10"
    style="display: grid; justify-content: center; align-items: center"
  >
    <div>{{ cardContent.card_date?.substring(0, 10) }}</div>
    <div style="font-size: 0.8em">{{ time_ago(cardContent.card_date) }}</div>
  </div>
  <!-- == -->
  <div
    fxFlex="12"
    style="display: flex; justify-content: center; align-items: center"
  >
    <mat-icon style="color: #8b2f00">place</mat-icon>
    <span>{{ cardContent.card_value_2 }}</span>
  </div>
  <!-- == -->
  <div
    *ngIf="fnIsRole('ADMIN')"
    fxFlex="14"
    style="display: flex; justify-content: center; align-items: center"
  >
    <mat-slide-toggle
      [(ngModel)]="cardContent.flag_1"
      (ngModelChange)="putIsPublic($event)"
    >
      {{ cardContent.flag_1 ? "pública" : "privado" }}
    </mat-slide-toggle>
  </div>
  <!-- == -->
  <div
    *ngIf="fnIsRole('USER')"
    fxFlex="14"
    style="
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
    "
    [ngStyle]="{ color: cardContent.flag_1 ? '#3f51b5' : '#999999' }"
  >
    {{ cardContent.flag_1 ? "pública" : "privado" }}
  </div>
  <!-- == -->
  <div
    fxFlex="14"
    style="display: flex; justify-content: center; align-items: center"
  >
    <button
      mat-icon-button
      color="primary"
      (click)="fnItem(cardContent.card_id)"
    >
      <mat-icon>remove_red_eye</mat-icon>
    </button>

    <button
      mat-icon-button
      color="primary"
      (click)="fnEditItem(cardContent.card_id)"
    >
      <mat-icon>edit</mat-icon>
    </button>

    <button
      mat-icon-button
      color="warn"
      (click)="fnDeleteItem(cardContent.card_id)"
    >
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>
